(function () {
    Number.prototype.hasFlag = function (flag) {
        return (this & flag) === flag;
    };

    history.pushState = (function () {
        const original = history.pushState;

        return function () {
            const ret = original.apply(this, arguments);
            window.dispatchEvent(new Event("pushstate"));
            window.dispatchEvent(new Event("locationchange"));
            return ret;
        };
    })();

    history.replaceState = (function () {
        const original = history.replaceState;

        return function () {
            const ret = original.apply(this, arguments);
            window.dispatchEvent(new Event("replacestate"));
            window.dispatchEvent(new Event("locationchange"));
            return ret;
        };
    })();

    window.addEventListener("popstate", function () {
        window.dispatchEvent(new Event("locationchange"));
    });

    window.addEventListener("locationchange", function () {
        const currentUri = new window.URI(window.location.href);
        const path = `${currentUri.pathname()}${currentUri.search()}${currentUri.hash()}`;

        // #region Change Language hypertext links
        $(".dropdown-language .dropdown-menu li.navi-item a.navi-link").each(function () {
            const uri = new window.URI($(this).attr("href"));
            const query = uri.search(true);
            query["returnUrl"] = path;

            uri.search(query);
            $(this).attr("href", uri.toString());
        });
        // #endregion

        // #region Lock Session button
        $("#UserProfileLockSessionReturnUrl").val(path);
        // #endregion
    });
})();

(function ($) {
    abp.ajax.defaultError405 = {
        message: abp.localization.abpWeb('DefaultError405'),
        details: abp.localization.abpWeb('DefaultErrorDetail405')
    };

    const defaultSourceName = $("body").data("localization-default-source-name");
    if (defaultSourceName) {
        abp.localization.defaultSourceName = defaultSourceName;
    }

    const momentLocale = $("body").data("moment-locale");
    if (momentLocale) {
        window.moment.locale(); //Localizing moment.js
    }

    $(function () {
        if ($("html").attr("dir") === "rtl") {
            window.toastr.options.rtl = true;
        }

        $.extend(abp.ui, {
            setBusy: (function () {
                var original = abp.ui.setBusy;
                return function (elm, optionsOrPromise) {
                    original(elm, optionsOrPromise);

                    if (!elm) {
                        $(".blockUI.blockOverlay").css("position", "fixed");
                        $(".spinner").css("position", "fixed");
                    }
                };
            })(),
            clearBusy: (function () {
                var original = abp.ui.clearBusy;
                return function (elm) {
                    if (!elm) {
                        $(".blockUI.blockOverlay").css("position", "absolute");
                        $(".spinner").css("position", "absolute");
                    }

                    original(elm);
                };
            })()
        });

        $.extend(abp.ajax, {
            handleResponse: function (data, userOptions, $dfd, jqXhr) {
                // 'userOptions' is actually the options passed to abp.ajax
                // 'userOptions.errorCallback' is a callback function which will be executed when data.success === false
                // and when the error modal is closed.
                var options = $.extend(true, {}, abp.ajax.defaultOpts, userOptions);

                if (data) {
                    if (data.success === true) {
                        $dfd && $dfd.resolve(data.result, data, jqXhr);
                        options.success && options.success(data.result, data, jqXhr);

                        if (data.targetUrl) {
                            abp.ajax.handleTargetUrl(data.targetUrl);
                        }
                    } else if (data.success === false) {
                        let messagePromise = null;

                        if (data.error) {
                            if (options.abpHandleError !== false) {
                                if (data.error.validationErrors && data.error.validationErrors.length > 0) {
                                    // the error is validation related, so list down the errors.
                                    const $messageContainer = $('<div class="text-left"></div>');
                                    var appLocalizationSource = abp.localization.getSource("AbpWeb");
                                    $messageContainer.append($(`<p>${appLocalizationSource("ValidationNarrativeTitle")}</p>`));

                                    const $errorList = $("<ul></ul>");
                                    $messageContainer.append($errorList);

                                    $.each(data.error.validationErrors, function () {
                                        let errorCode = "";
                                        if (this.errorCode) {
                                            errorCode = ` (${appLocalizationSource("ErrorCode")}: ${this.errorCode})`;
                                        }

                                        $errorList.append(`<li>${this.message}${errorCode}</li>`);
                                    });

                                    if (data.error.details) {
                                        messagePromise = abp.message.error($messageContainer.get(0).outerHTML, data.error.message, { isHtml: true });
                                    } else {
                                        messagePromise = abp.message.error($messageContainer.get(0).outerHTML, null, { isHtml: true });
                                    }
                                } else {
                                    messagePromise = abp.ajax.showError(data.error);
                                }
                            }
                        } else {
                            data.error = abp.ajax.defaultError;
                        }

                        abp.ajax.logError(data.error);

                        $dfd && $dfd.reject(data.error, jqXhr);
                        options.error && options.error(data.error, jqXhr);

                        if (options.errorCallback) {
                            if (messagePromise) {
                                messagePromise.done(function () {
                                    options.errorCallback(data.error, jqXhr);
                                });
                            } else {
                                options.errorCallback(data, jqXhr);
                            }
                        }

                        if (options.abpHandleError !== false) {
                            if (jqXhr.status === 401 || data.targetUrl) {
                                abp.ajax.handleUnAuthorizedRequest(messagePromise, data.targetUrl);
                            }
                        }
                    } else { //not wrapped result
                        $dfd && $dfd.resolve(data, null, jqXhr);
                        options.success && options.success(data, null, jqXhr);
                    }
                } else { //no data sent to back
                    $dfd && $dfd.resolve(jqXhr);
                    options.success && options.success(jqXhr);
                }
            },
            handleNonAbpErrorResponse: function (jqXHR, userOptions, $dfd) {
                var options = $.extend(true, {}, abp.ajax.defaultOpts, userOptions);

                if (options.abpHandleError !== false) {
                    switch (jqXHR.status) {
                        case 401:
                            abp.ajax.handleUnAuthorizedRequest(
                                abp.ajax.showError(abp.ajax.defaultError401),
                                window.location.href);
                            break;

                        case 403:
                            abp.ajax.showError(abp.ajax.defaultError403);
                            break;

                        case 404:
                            abp.ajax.showError(abp.ajax.defaultError404);
                            break;

                        case 405:
                            // problem with anti forgery token
                            abp.ajax.showError(abp.ajax.defaultError405)
                                .done(function () {
                                    window.location.reload();
                                });
                            break;

                        default:
                            abp.ajax.showError(abp.ajax.defaultError);
                            break;
                    }
                }

                $dfd.reject.apply(this, arguments);
                options.error && options.error.apply(this, arguments);
            }
        });

        $(document).on("click", ".select-all", function (e) {
            e.preventDefault();

            const $container = $(this).parent(".select-all-none").parent();
            $('input[type="checkbox"]', $container).prop("checked", true).refreshMetronicSwitch();
        });
        $(document).on("click", ".select-none", function (e) {
            e.preventDefault();

            const $container = $(this).parent(".select-all-none").parent();
            $('input[type="checkbox"]', $container).prop("checked", false).refreshMetronicSwitch();
        });

        $(document).on("focusout", 'input[type="date"], input[type="datetime-local"], input[type="email"], input[type="month"], input[type="number"], input[type="search"], input[type="tel"], input[type="text"], input[type="time"], input[type="url"], input[type="week"], textarea', function () {
            const name = $(this).attr("name");
            if (name && name.toLowerCase().indexOf("password") >= 0) {
                return;
            }

            const value = $(this).val();
            if (typeof value === "string" || value instanceof String) {
                $(this).val("");
                $(this).val(value.trim());
            }
        });

        let tempusDominusWidgetHideTimer = false;
        $(document).on("focusout", ".tempus-dominus input", function () {
            const $this = $(this);
            const td = $this.closest(".tempus-dominus").data(window.tempusDominus.Namespace.dataKey);
            if (td) {
                // we don't need the block of codes below anymore. It seems that Tempus Dominus now will clear the internal date when the input is empty.
                //if ($this.val() === "") {
                //    //td.dates.clear();
                //    td.dates.setValue(null); // for some reasons "dates.clear()" doesn't work, so we're using "dates.setValue()"
                //}

                if (td.display._isVisible) {
                    td.widgetHideTimer = setTimeout(function () {
                        const $activeElement = $(document.activeElement); // assign the current Active Element to a variable.
                        td.hide(); // .hide() will click on the toggle button and shift focus to the button.
                        $activeElement.focus(); // therefore we need to move the focus back to the previous Active Element.

                        delete td.widgetHideTimer;
                        tempusDominusWidgetHideTimer = false;
                    }, 150);
                    tempusDominusWidgetHideTimer = td.widgetHideTimer;
                }
            }
        });
        $(document).on("focusin", ".tempus-dominus input", function () {
            const td = $(this).closest(".tempus-dominus").data(window.tempusDominus.Namespace.dataKey);
            if (td) {
                if (td.widgetHideTimer) {
                    clearTimeout(td.widgetHideTimer);
                }
            
                if (!td.display._isVisible && !td.suppressShowWidgetOnFocus) {
                    td.show();
                }

                delete td.suppressShowWidgetOnFocus;
            }
        });
        $(document).on("focusin", ".tempus-dominus button", function () {
            const td = $(this).closest(".tempus-dominus").data(window.tempusDominus.Namespace.dataKey);
            if (td) {
                if (td.widgetHideTimer) {
                    clearTimeout(td.widgetHideTimer);
                }
            }
        });
        $(document).on("click", ".tempus-dominus-widget", function () {
            clearTimeout(tempusDominusWidgetHideTimer);
        });
        $(document).on("keydown", ".tempus-dominus input", function (e) {
            const td = $(this).closest(".tempus-dominus").data(window.tempusDominus.Namespace.dataKey);
            switch (e.key) {
                case app.consts.keyboardKey.arrowUp:
                    td.hide();
                    td.suppressShowWidgetOnFocus = true;
                    $(this).focus();
                    break;

                case app.consts.keyboardKey.arrowDown:
                    td.show();
                    break;
            }
        });
        $(document).on("keydown", function (e) {
            function closeTempusDominusWidgets(maintainFocus) {
                let container = "body";
                const $modals = $(".modal.show");
                if ($modals.length > 0) {
                    container = _.last($modals);
                }

                $(".tempus-dominus", container).each(function () {
                    const td = $(this).data(window.tempusDominus.Namespace.dataKey);
                    if (td.display._isVisible) {
                        td.hide();

                        if (maintainFocus) {
                            td.suppressShowWidgetOnFocus = true;
                            $(td.optionsStore.input).focus();
                        }
                    }
                });
            }

            switch (e.key) {
                case app.consts.keyboardKey.enter:
                    if ($(".tempus-dominus-widget.show").length > 0) {
                        closeTempusDominusWidgets();
                    }
                    break;

                case app.consts.keyboardKey.escape:
                    if ($(".tempus-dominus-widget.show").length > 0) {
                        closeTempusDominusWidgets(true);
                    } else if ($(".selectize .selectize-input.focus:not(.input-active)").length > 0) {
                        // if a selectize has just changed its value, pressing ESC will not attempt to close the modal it is in.
                        // Here we try to close the modal explicitly.
                        const $modals = $(".modal.show");
                        if ($modals.length > 0) {
                            const $modal = $(_.last($modals));
                            $modal.modal("hide");
                        }
                    }
                    break;
            }
        });

        $(document).on("focusin", 'input[type="date"], input[type="datetime-local"], input[type="email"], input[type="password"], input[type="month"], input[type="number"], input[type="search"], input[type="tel"], input[type="text"], input[type="time"], input[type="url"], input[type="week"], textarea', function () {
            $(this).select();
        });

        $(document).on("focusin", '.btn-group-toggle input[type="radio"]', function () {
            $(this).prop("checked", true);
        });

        $("#AbpPageAlerts .alert").on("closed.bs.alert", function () {
            app.dataTables.adjustColumns();
        });

        $(document).on("hide.bs.modal", ".modal", function (e) {
            const $modal = $(e.target);

            if (!e.isDefaultPrevented()) {
                if ($modal.data("prevent-close")) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }

            // The code below is to resolve the error "Blocked aria-hidden on an element because its descendant retained focus." due to modern browser updates.
            // https://stackoverflow.com/a/79234586
            if (document.activeElement) {
                document.activeElement.blur();
            }
        });

        $(document).on("hidden.bs.modal", ".modal", function (e) {
            // Bootstrap by default doesn't support stacked Modals.
            // Closing a modal will remove the class "modal-open" from the <body> without checking if there are other opened Modals.
            // This remove the scrolling capabilities of other opened Modals.
            // The codes below will check if there are other opened Modals and re-add the class "modal-open" to the <body>.
            if ($(".modal.show").length > 0) {
                if (!$("body").hasClass("modal-open")) {
                    $("body").addClass("modal-open");
                }
            }
        });

        $(document).on("click", ".modal button.close-button, .modal button.close", function () {
            // if the close button of a modal is clicked, it will trigger the close of the modal ignoring the prevent-close placed by dropdowns, datetime pickers, popovers
            $(this).closest(".modal").data("prevent-close", false);
        });

        // Dispose of the tooltips initialized by Metronic first.
        $('[data-toggle="tooltip"]').each(function () {
            $(this).tooltip("dispose");
        });
        // Then re-initialize the tooltips to cater for dynamically added tooltips later on.
        $(document).tooltip({
            selector: '[data-toggle="tooltip"], [data-tooltip="true"], .tempus-dominus-widget [data-action][title]',
            boundary: "viewport",
            template: '<div class="tooltip tooltip-dark" role="tooltip">\
                <div class="arrow"></div>\
                <div class="tooltip-inner"></div>\
            </div>',
            trigger: "hover"
        });
        $(document).on("click", 'button[data-toggle="tooltip"], button[data-tooltip="true"]', function () {
            $(this).tooltip("hide");
        });

        // Bootstrap Tooltip whitelist of HTML tags
        $.fn.tooltip.Constructor.Default.whiteList.kbd = [];

        // Metronic switch
        $(document).on("change", '.switch[data-color-set] input[type="checkbox"]', function () {
            $(this).refreshMetronicSwitch();
        });

        // prevent the modal that the dropdown is in (if any) from closing when pressing the ESC key. The ESC key will close the dropdown without also
        // closing the modal. Only after the dropdown is close, subsequent ESC key press will close the modal.
        // this behaviour can be turned off by adding a HTML custom data attribute 'data-prevent-modal-close="false"' on the dropdown itself.
        $(document)
            .on("show.bs.dropdown", ".modal .dropdown, .modal .btn-group", function () {
                const $dropdown = $(this);

                // the default value of "prevent-modal-close" is true
                if (typeof ($dropdown.data("prevent-modal-close")) === "undefined" || $dropdown.data("prevent-modal-close")) {
                    $dropdown.closest(".modal").data("prevent-close", true);
                }
            })
            .on("hidden.bs.dropdown", ".modal .dropdown, .modal .btn-group", function () {
                $(this).closest(".modal").removeData("prevent-close");
            });

        // prevent dropdown from closing when it has the HTML custom data attribute `prevent-close="true"` unless the hide attempt is initiated by
        // the dropdown trigger (button) which when clicked again would close the dropdown, in this case allow the dropdown to close by not preventing it.
        $(document)
            .on("hide.bs.dropdown", ".dropdown, .btn-group", function (e) {
                const $dropdown = $(this);

                if ($dropdown.data("prevent-close-once")) {
                    $dropdown.removeData("prevent-close-once");

                    e.preventDefault();
                    e.stopPropagation();
                } else if ((!$dropdown.is(e.target)
                    && !$.contains($dropdown.get(0), e.target)
                    && $(this).data("prevent-close"))) {
                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    const $modal = $dropdown.closest(".modal");
                    if ($modal.length > 0) {
                        // if the dropdown is contained inside a modal.
                        if (e.clickEvent && e.clickEvent.target) {
                            const $cancelButton = $(".close-button", $modal);
                            const $closeButton = $(".close", $modal);

                            if ($cancelButton.is(e.clickEvent.target) || $.contains($cancelButton.get(0), e.clickEvent.target)
                                || $closeButton.is(e.clickEvent.target) || $.contains($closeButton.get(0), e.clickEvent.target)) {
                                // if the "Cancel" or "Close" button of a modal is clicked while the dropdown is open, close the modal (in addition to closing the dropdown which is by default handled).
                                $modal.removeData("prevent-close");

                                if ($cancelButton.is(e.clickEvent.target) || $.contains($cancelButton.get(0), e.clickEvent.target)) {
                                    setTimeout(function () {
                                        $cancelButton.click();
                                    });
                                } else if ($closeButton.is(e.clickEvent.target) || $.contains($closeButton.get(0), e.clickEvent.target)) {
                                    setTimeout(function () {
                                        $closeButton.click();
                                    });
                                } else {
                                    $modal.modal("hide");
                                }
                                return;
                            }
                        }
                    }

                    // if the dropdown is allowed to close, attempt to close depending popover as well.
                    const dependantPopover = $dropdown.data("dependant-popover");
                    if (dependantPopover) {
                        const $dependantPopover = $(dependantPopover);
                        let closePrevented = false;

                        const popoverId = $dependantPopover.data("popover-id");
                        if (popoverId) {
                            const $popoverElement = $(`#${popoverId}`);
                            if ($popoverElement.length > 0) {
                                if (e.clickEvent && e.clickEvent.target) {
                                    if ($popoverElement.is(e.clickEvent.target) || $.contains($popoverElement.get(0), e.clickEvent.target)
                                        || typeof (e.clickEvent.pointerType) === "undefined" /* the dropdown is trying to be closed with ESC key, therefore prevent it from closing */) {
                                        // but first if there's a click event on the popover element, prevent the dropdown from closing.
                                        e.preventDefault();
                                        e.stopPropagation();

                                        closePrevented = true;
                                    }
                                }
                            }
                        }

                        if (!closePrevented) {
                            // dropdown is allowed to close, close dependant popover as well.
                            $dependantPopover.popover("hide");
                        }
                    }
                }
            });

        // handle events of dropdown items when clicked require confirmation
        $(document).on("click", ".dropdown-menu > .dropdown-item.dropdown-item-confirmation, .button-confirmation", function (e) {
            e.stopPropagation(); // to prevent the dropdown menu from closing upon clicking the dropdown item.
            e.preventDefault(); // clicking the dropdown item is supposed to only show the popover for confirmation, therefore prevent other behaviours.

            const $dropdownItem = $(this);

            // close existing popover that is opened by dropdown items within the dropdown menu
            const $dropdownMenu = $dropdownItem.closest(".dropdown-menu");
            const $dropdownItems = $dropdownMenu.find(".dropdown-item.dropdown-item-confirmation");
            $dropdownItems.each(function () {
                const $item = $(this);

                const popoverId = $item.data("popover-id");
                if (popoverId) {
                    $item.removeData("popover-id");

                    const $popover = $(`#${popoverId}`);
                    if ($popover.length > 0) {
                        setTimeout(function () {
                            $item.popover("hide");
                        });

                        return false;
                    }
                }
            });

            const $dropdown = $dropdownItem.closest(".dropdown, .btn-group");
            const previousPopoverTriggerElement = $dropdown.data("dependant-popover");
            if (previousPopoverTriggerElement) {
                // remove dependee-dropdown-item of previous popover when a new popover is about to be shown
                // so that the closing of the previous popover will not trigger a "focus" on its associated dropdown item.
                $dropdown.removeData("dependant-popover");
                previousPopoverTriggerElement.removeData("dependee-dropdown-item");

                if (previousPopoverTriggerElement.get(0) === $dropdownItem.get(0)) {
                    // a popover is already open for this dropdown item, clicking again on the same dropdown item should close the popover and not continue anymore.
                    return;
                }
            }

            const $dropdownToggle = $(".dropdown-toggle", $dropdown);
            const popoverOptions = {
                trigger: "manual",
                preventModalClose: false
            };
            if ($dropdownItem.data("popover-container")) {
                popoverOptions.container = $dropdownItem.data("popover-container");
            }

            const popoverTriggerElement = $dropdownItem.confirmation(
                app.localize("AreYouSure"),
                $dropdownItem.data("prompt-confirmation"),
                function (isConfirmed) {
                    if (isConfirmed) {
                        let dto = {};
                        const arguments = $dropdownItem.data("arguments");
                        //if (arguments) {
                        //    if (typeof arguments === "string" || arguments instanceof String) {
                        //        dto = JSON.parse(app.utils.html.htmlDecodeText(arguments));
                        //    } else {
                        //        dto = arguments;
                        //    }
                        //}
                        
                        let idKey = $dropdownItem.data("id-key");
                        if (!idKey) {
                            idKey = "id";
                        }

                        const args = {};
                        args[idKey] = $dropdownItem.data("id");

                        dto = $.extend({}, dto, args);
                        dto = app.camelizeKeys(dto);

                        $dropdown.removeData("prevent-close");
                        $dropdown.removeData("prevent-close-once");
                        $dropdownToggle.dropdown("hide");

                        let $modalManager = null;
                        const $modal = $dropdownItem.closest(".modal");
                        if ($modal.length > 0) {
                            $modalManager = $modal.data("modal-manager");
                        }

                        const busyContainer = $dropdownItem.data("busy-container"); // .busy-container is an element to set the "busy" overlay on.
                        if (busyContainer) {
                            abp.ui.setBusy(busyContainer);
                        } else {
                            if ($modalManager) {
                                $modalManager.setBusy(true);
                            } else {
                                abp.ui.setBusy();
                            }
                        }

                        let action = $dropdownItem.data("action");
                        action = typeof action === "function" ? action : eval(action);

                        var result = action.call($modalManager ?? window, dto);
                        if (result && (result.always || result["finally"])) { // if result is a promise
                            result
                                .done(function (data) {
                                    let successCallback = $dropdownItem.data("success-callback");

                                    if (busyContainer) {
                                        abp.ui.clearBusy(busyContainer);
                                    } else {
                                        if ($modalManager) {
                                            if (!successCallback) {
                                                $modalManager.reset();
                                            }
                                        } else {
                                            abp.ui.clearBusy();

                                            // Todo: refresh the page if the form is not contained in a modal
                                        }
                                    }

                                    if (successCallback) {
                                        successCallback = typeof successCallback === "function" ? successCallback : eval(successCallback);

                                        if (data === true || data === false) {
                                            data = {
                                                result: data
                                            };
                                        }
                                        data = $.extend({}, $dropdownItem.data("data"), data);

                                        successCallback.call($modalManager ?? window, dto, data);
                                    }
                                })
                                .always(function () {
                                    if (busyContainer) {
                                        abp.ui.clearBusy(busyContainer);
                                    } else {
                                        if ($modalManager) {
                                            $modalManager.setBusy(false);
                                        } else {
                                            abp.ui.clearBusy();
                                        }
                                    }
                                });
                        } else {
                            abp.ui.clearBusy();
                        }
                    }
                },
                popoverOptions);

            const $popoverTriggerElement = $(popoverTriggerElement)
                .data("dependee-dropdown-item", $dropdownItem.get(0)) // the dropdown item that the popover is depending on. When the dropdown closes, so will the popover.
                .one("show.bs.popover", function () {
                    $dropdown.data("prevent-close", true);
                })
                .one("hide.bs.popover", function () {
                    $dropdown.removeData("prevent-close");
                    setTimeout(function () {
                        $dropdown.removeData("dependant-popover");
                    });
                })
                .one("shown.bs.popover", function () {
                    const popoverId = $(this).data("popover-id");

                    if (popoverId) {
                        const $popover = $(`#${popoverId}`);

                        $popover.on("focus", "button", function () {
                            // whenever a button or input receives focus, it will close other dropdown menus.
                            // Since the button is inside the popover and the popover depends on the dropdown, prevent the dropdown from closing when button receives focus.
                            $dropdown.data("prevent-close-once", true);
                        });
                    }
                });

            // the popover is depending on the dropdown. When the dropdown closes, so will the popover.
            $dropdown.data("dependant-popover", popoverTriggerElement);

            $popoverTriggerElement.popover("show");
        });

        // Tempus Dominus DateTime picker
        window.tempusDominus.extend(window.tempusDominus.plugins.fa_duotone.load);
        window.tempusDominus.extend(window.tempusDominus.plugins.moment_timezone_parse.load);
        if (window.tempusDominus.locales) {
            const currentLocale = window.tempusDominus.locales[Object.keys(window.tempusDominus.locales)[0]];
            window.tempusDominus.loadLocale(currentLocale);
            window.tempusDominus.locale(currentLocale.name);
        }
        //window.tempusDominus.DefaultOptions.allowInputToggle = true; // not going to use this, we've implemented a more flexible method which is more aligned to our usage requirements.
        window.tempusDominus.DefaultOptions.localization.dateFormats = {
            L: abp.dateTimeFormatter.getShortDateFormat(),
            LL: abp.dateTimeFormatter.getShortDate2Format(),
            LLL: abp.dateTimeFormatter.getLongDateFormat(),
            LLLL: abp.dateTimeFormatter.getLongDate2Format(),
            LT: abp.dateTimeFormatter.getShortTimeFormat(),
            LTS: abp.dateTimeFormatter.getLongTimeFormat()
        };
        window.tempusDominus.DefaultOptions.localization.format = "L LT";

        $(document).on("change.td", ".tempus-dominus", function () {
            // for unknown reasons, this event is triggered twice when changing the date in the text input.
            // This event is triggered only once though when changing the date by selecting from the dropdown date picker.
            // We need a mechanism to ignore the second event trigger.
            const td = $(this).data(window.tempusDominus.Namespace.dataKey);

            if (!td.suppressChangeEvent) { // a temporary property to suppress from processing when this event is being triggered the second time.
                td.focusTimeout = setTimeout(function () {
                    td.suppressShowWidgetOnFocus = true;
                    $(td.optionsStore.input).focus();
                }, 30);
            }
        });
        $(document).on("change", ".tempus-dominus input", function () {
            const validator = $(this).closest("form").data("validator");
            if (validator) {
                validator.element(this);
            }

            const td = $(this).closest(".tempus-dominus").data(window.tempusDominus.Namespace.dataKey);
            clearTimeout(td.focusTimeout);
            delete td.focusTimeout;

            td.suppressChangeEvent = true; // a temporary marker to prevent the event handler above from processing the second time.
            setTimeout(function () {
                delete td.suppressChangeEvent; // after 50ms, this property will be removed so that subsequent event handler trigger will continue to process.
            }, 50);
        });

        // Pop ups that should prevent modal from closing when Esc is pressed.
        $(document).on("show.td", ".tempus-dominus", function () {
            const picker = this;

            $(picker).closest(".modal").data("prevent-close", true);

            setTimeout(function () {
                $("input", picker).focus();
            });
        });
        $(document).on("hide.td", ".tempus-dominus", function () {
            const $modal = $(this).closest(".modal");
            setTimeout(function () {
                $modal.data("prevent-close", false);
            });
        });

        $(document).on("select2:open", ".modal select", function () {
            $(this).closest(".modal").data("prevent-close", true);
        });
        $(document).on("select2:close", ".modal select", function () {
            const $modal = $(this).closest(".modal");
            setTimeout(function () {
                $modal.data("prevent-close", false);
            });
        });

        $(document).on("open:countrydropdown", ".modal .iti__tel-input", function () {
            $(this).closest(".modal").data("prevent-close", true);

            const iti = $(this).intlTelInput();
            if (!iti.highlightedItem) {
                const item = $(".iti__country:first", iti.countryList).get(0);

                iti._highlightListItem(item, false);
            }

            // resize the width of the Country dropdown
            const $iti = $(this).closest(".iti");
            const $inputGroupAppend = $(".input-group-append", $iti);
            if ($inputGroupAppend.length > 0) {
                const itiId = $(this).data("intl-tel-input-id");
                const $itiDropdownContent = $(`#iti-${itiId}__dropdown-content`);
                const itiDropdownContentWidth = parseFloat($itiDropdownContent.css("width").replace("px", ""));
                const inputGroupAppendWidth = parseFloat($inputGroupAppend.css("width").replace("px", ""));
                const newItiDropdownContentWidth = itiDropdownContentWidth + inputGroupAppendWidth;
                $itiDropdownContent.css("width", newItiDropdownContentWidth + "px");
            }
        });
        $(document).on("close:countrydropdown", ".modal .iti__tel-input", function () {
            const $modal = $(this).closest(".modal");
            setTimeout(function () {
                $modal.data("prevent-close", false);
            });
        });

        // numeric input
        $(document).on("click", ".input-spinner-container .btn.btn-decrement, .input-spinner-container .btn.btn-increment", function () {
            const validator = $(this).closest("form").data("validator");
            if (validator) {
                const inputSpinner = $(".input-spinner", $(this).closest(".input-spinner-container"));
                validator.element(`#${inputSpinner.attr("id")}`);
            }
        });

        // warns when no localization string is defined for a key.
        abp.localization.localize = (function () {
            const original = abp.localization.localize;
            return function (key, sourceName) {
                const sn = sourceName || abp.localization.defaultSourceName;

                var source = abp.localization.values[sn];

                if (source) {
                    var value = source[key];
                    if (value == undefined) {
                        abp.log.warn(`Could not find '${key}' in localization source '${sn}'!`);
                    }
                }

                return original.apply(this, arguments);
            };
        })();

        if (window.kendo) {
            window.kendo.init("body");
        }

        if ($("#script_tidio").length) {
            var chatLoaded = function () {
                if (this.innerHTML) {
                    $("#tidio-chat-iframe").css({
                        "z-index": 1000000005,
                        "margin-right": "40px"
                    });
                    $("body").off("DOMNodeInserted", "#tidio-chat", chatLoaded);
                }
            };
            $("body").on("DOMNodeInserted", "#tidio-chat", chatLoaded);
        }

        app.init();
        app.focusFirstElement();
    });
})(jQuery);

(function ($) {
    $(function () {
        $(document).on("hide.bs.modal", ".modal", function (e) {
            /*
            Pressing Esc on the keyboard will attempt to close the Modal.
            If a SweetAlert is opened in front of a Modal (SweetAlert is always assumed to be in front of a Modal except for Inactivity Controller Modal in which case Inactivity Controller Modal will be in front of SweetAlert), 
            pressing Esc will attempt to close both the SweetAlert and the Modal.
            This fix will prevent the Modal from closing the Modal when a SweetAlert is opened.
            */
            if (window.sweetAlert.getState().isOpen && !_.some(app.modalManagers, { modalClass: "InactivityControllerNotifyModal" })) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        });

        /*
        https://github.com/t4t5/sweetalert/issues/127
        */
        window.sweetAlert.close = (function () {
            var original = window.sweetAlert.close;
            return function () {
                original();
                window.onkeydown = null;
            };
        })();

        /*
        Pressing Esc on the keyboard to bring up a SweetAlert will close it immediately because
        onkeydown will bring up the SweetAlert and onkeyup will close it.
        Therefore handle Esc manually by closing the SweetAlert only onkeydown of Esc
        */
        window.sweetAlert.setDefaults({
            closeOnEsc: false
        });
        $(document).on("keydown", function (e) {
            if (e.which === 27) {
                // Esc
                if (window.sweetAlert.getState().isOpen) {
                    setTimeout(function () {
                        window.sweetAlert.close();
                    });
                }
            }
        });

        /*
        After a SweetAlert is closed, focus back on the previous Modal
        */
        function focusPreviousModal() {
            const $visibleModals = $(".modal:visible");
            if ($visibleModals.length) {
                const visibleModal = $visibleModals.get($visibleModals.length - 1);
                visibleModal.focus();
            }
        }

        abp.message.info = (function () {
            const original = abp.message.info;
            return function (message, title, options) {
                /*
                When a Bootstrap Modal is opened and a SweetAlert is opened on top of it, the SweetAlert buttons don't receive focus.
                This is because there's an event listener that instantly sets focus to the Bootstrap Modal if focus is given to an element
                that isn't inside it.
                https://fantashit.com/text-input-not-clickable-when-bootstrap-modal-is-open/
                */
                let originalEnforceFocus;
                $.each($._data(document, "events")["focusin"],
                    function (index, value) {
                        if (value.namespace === "bs.modal") {
                            originalEnforceFocus = value.handler;
                            return false;
                        }
                    });

                if (originalEnforceFocus) {
                    $(document).off("focusin.bs.modal");
                }

                const $deferred = original(message, title, options);
                $deferred.always(function () {
                    if (originalEnforceFocus) {
                        $(document).on("focusin.bs.modal", originalEnforceFocus);
                    }
                    focusPreviousModal();
                });

                return $deferred;
            };
        })();

        abp.message.success = (function () {
            const original = abp.message.success;
            return function (message, title, options) {
                let originalEnforceFocus;
                $.each($._data(document, "events")["focusin"],
                    function (index, value) {
                        if (value.namespace === "bs.modal") {
                            originalEnforceFocus = value.handler;
                            return false;
                        }
                    });

                if (originalEnforceFocus) {
                    $(document).off("focusin.bs.modal");
                }

                const $deferred = original(message, title, options);
                $deferred.always(function () {
                    if (originalEnforceFocus) {
                        $(document).on("focusin.bs.modal", originalEnforceFocus);
                    }
                    focusPreviousModal();
                });

                return $deferred;
            };
        })();

        abp.message.warn = (function () {
            const original = abp.message.warn;
            return function (message, title, options) {
                let originalEnforceFocus;
                $.each($._data(document, "events")["focusin"],
                    function (index, value) {
                        if (value.namespace === "bs.modal") {
                            originalEnforceFocus = value.handler;
                            return false;
                        }
                    });

                if (originalEnforceFocus) {
                    $(document).off("focusin.bs.modal");
                }

                const $deferred = original(message, title, options);
                $deferred.always(function () {
                    if (originalEnforceFocus) {
                        $(document).on("focusin.bs.modal", originalEnforceFocus);
                    }
                    focusPreviousModal();
                });

                return $deferred;
            };
        })();

        abp.message.error = (function () {
            const original = abp.message.error;
            return function (message, title, options) {
                let originalEnforceFocus;
                $.each($._data(document, "events")["focusin"],
                    function (index, value) {
                        if (value.namespace === "bs.modal") {
                            originalEnforceFocus = value.handler;
                            return false;
                        }
                    });

                if (originalEnforceFocus) {
                    $(document).off("focusin.bs.modal");
                }

                const $deferred = original(message, title, options);
                $deferred.always(function () {
                    if (originalEnforceFocus) {
                        $(document).on("focusin.bs.modal", originalEnforceFocus);
                    }
                    focusPreviousModal();
                });

                return $deferred;
            };
        })();

        abp.message.confirm = (function () {
            const original = abp.message.confirm;
            return function (message, title, callback, options) {
                let originalEnforceFocus;
                $.each($._data(document, "events")["focusin"],
                    function (index, value) {
                        if (value.namespace === "bs.modal") {
                            originalEnforceFocus = value.handler;
                            return false;
                        }
                    });

                if (originalEnforceFocus) {
                    $(document).off("focusin.bs.modal");
                }

                const $deferred = original(message, title, callback, options);
                $deferred.always(function () {
                    if (originalEnforceFocus) {
                        $(document).on("focusin.bs.modal", originalEnforceFocus);
                    }
                    focusPreviousModal();
                });

                return $deferred;
            };
        })();

        // overwrite the behaviour of anti forgery token taken from cookie. The cookie is not HttpOnly cookie therefore it should not be used anymore.
        // replaced by writing to the data attribute of the body
        abp.security.antiForgery.getToken = function () {
            return $("body").data("anti-forgery-token");
        };

        abp.notify.entityStatusChanged = function (entityStatus, entityName) {
            switch (entityStatus) {
                case app.enums.entityStatus.active:
                    if (entityName) {
                        abp.notify.success(app.localize("RestoreEntityNotification", entityName));
                    } else {
                        abp.notify.success(app.localize("RestoreRecordConfirmation"));
                    }
                    break;

                case app.enums.entityStatus.inactive:
                    if (entityName) {
                        abp.notify.warn(app.localize("DeactivateEntityNotification", entityName));
                    } else {
                        abp.notify.warn(app.localize("DeactivateRecordConfirmation"));
                    }
                    break;

                case app.enums.entityStatus.deleted:
                    if (entityName) {
                        abp.notify.error(app.localize("DeleteEntityNotification", entityName));
                    } else {
                        abp.notify.error(app.localize("DeleteRecordConfirmation"));
                    }
                    break;
            }
        };
    });
})(jQuery);

(function ($) {
    function getNextModalZIndex(currentModal) {
        const $currentModal = $(currentModal);
        if ($currentModal.length > 0) {
            const $modalBody = $(".modal-body.inactivity-controller", $currentModal);
            if ($modalBody.length > 0) {
                // if the modal is the Inactivity Controller Modal (which displays a countdown progress when idle for a period of time),
                // set the z-index to be greater than the z-index of sweet alert so that it will be shown on top of it.
                return 1000000030 + 1;
            }
        }

        const $modals = $(".modal.fade.show");
        const $lastModal = $modals.last();

        if ($lastModal.hasInlineCss("z-index")) {
            const previousZIndex = $lastModal.css("z-index");

            if (previousZIndex) {
                const zIndex = parseInt(previousZIndex, 10);

                return zIndex + 2;
            }
        }

        const modalBaseZIndex = 1000000006;
        const modalCount = $modals.length;

        return modalBaseZIndex + modalCount * 2;
    }

    /**
     * Extend on Bootstrap's Modal by appending a scroll to top button.
     * To cater for stacked Modals, the z-index of the Modals and their backdrops have to be specified individually.
     */
    $(function () {
        $(document).on("show.bs.modal", ".modal", function () {
            if (!$(this).data("has-init")) {
                const $modal = $(this);

                $modal.attr("data-scrolltop", "off");

                if (!$modal.hasInlineCss("z-index")) {
                    // only assign a computed z-index to the modal if it doesn't have an explicit inline css yet.
                    $modal.css("z-index", getNextModalZIndex($modal.get(0)));
                }

                window.app.modal.createScrollTopElement(this);

                $modal.on("click", ".scrolltop", function () {
                    $modal.parent().find(".modal, .modal-body, .modal-scrollable").scrollToTop();
                });

                const scrollEvent = function () {
                    const $this = $(this);
                    if ($this.scrollTop() >= 300) {
                        $modal.attr("data-scrolltop", "on");
                    } else {
                        $modal.attr("data-scrolltop", "off");
                    }
                };
                $modal.on("scroll", scrollEvent);
                $(".modal-body", $modal).on("scroll", scrollEvent);
                $(".modal-scrollable", $modal).on("scroll", scrollEvent);

                $(this).data("has-init", true);
            }
        });

        $(document).on("shown.bs.modal", ".modal", function (e) {
            const zindex = parseInt($(this).css("z-index"), 10) - 1;
            $(".modal-backdrop.fade.show").last().css("z-index", zindex);

            const $floatingScrolls = $(e.target).find(".fl-scrolls");
            $floatingScrolls.each(function () {
                const $scrollableBody = $(this).parent();
                if ($scrollableBody.is(":visible")) {
                    setTimeout(function () {
                        $scrollableBody.floatingScroll("update");
                    }, 100);
                }
            });
        });
    });
})(jQuery);

(function ($) {
    /**
     * Keyboard shortcuts
     */
    $(function () {
        const keyboardShortcutManager = new KeyboardShortcutManager(document,
            [
                new KeyboardShortcutItem([app.consts.keyboardKey.escape], null, function (e) {
                    if ($(".modal-backdrop").length > 0) {
                        return;
                    }

                    if ($(".offcanvas-overlay").length > 0) {
                        $(".offcanvas-overlay").click();
                    }
                }),
                new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "N"], { element: ".create-button", options: { placement: "left" } }, function (e) {
                    if (!app.isOverlayShown()) {
                        e.stopPropagation();
                        e.preventDefault();

                        if ($(".create-button").is(":visible")) {
                            $(".create-button").focus().click();
                        }
                    }
                }),
                new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "F"], { element: ".search-button", options: { placement: "left" } }, function (e) {
                    if (!app.isOverlayShown()) {
                        e.stopPropagation();
                        e.preventDefault();

                        if ($(".search-button").is(":visible")) {
                            $(".search-button").focus().click();
                        }
                    }
                }),

                new KeyboardShortcutItem([app.consts.keyboardKey.control, "Q"], ".reset-button", function (e, $tooltipTarget, manager) {
                    e.stopPropagation();
                    e.preventDefault();

                    if ($tooltipTarget.is(":visible")) {
                        $tooltipTarget.focus().click();
                    }
                }, "#SearchModal"),
                new KeyboardShortcutItem([app.consts.keyboardKey.control, "S"], ".save-button", function (e, $tooltipTarget, manager) {
                    e.stopPropagation();
                    e.preventDefault();

                    if ($tooltipTarget.is(":visible")) {
                        $tooltipTarget.focus().click();
                    }
                }, "#SearchModal"),
                new KeyboardShortcutItem([app.consts.keyboardKey.escape], ".close-button, .close", null, "#SearchModal")
            ]);
    });
})(jQuery);

(function ($) {
    if (window.KTUtil) {
        window.KTUtil.ready(function () {
            if (window.KTLayoutAsideToggle && window.KTLayoutAsideToggle.getToggle()) {
                // menu related
                const setMaxHeight = function () {
                    const $openedSubmenus = $("ul.menu-nav > li.menu-item.menu-item-open > .menu-submenu");
                    $openedSubmenus.each(function () {
                        const $submenu = $(this);
                        $submenu.css("max-height", "");
                        setTimeout(function () {
                            $submenu.css("max-height", $submenu.css("height"));
                        }, 100);
                    });
                };

                // if the menu is started minimized, the next time the menu is expanded, perform height calculation on opened submenus so that
                // the next time the menu is minimized, css transitions can kick in.
                // minimized menu has in the body tag the "aside-minimize" class, when it's hovered, an additional class "aside-minimize-hover" is appended.
                // when the menu is restored to expanded state, "aside-minimize" class is removed as well as the "aside-minimize-hover" (if it was present)
                if (window.KTLayoutAsideToggle.getToggle().getState() === "on") {
                    const classWatcher = new ClassWatcher($("body").get(0), ["aside-minimize", "aside-minimize-hover"], function (currentClasses, previousClasses) {
                        if (_.includes(currentClasses, "aside-minimize-hover") || !_.includes(currentClasses, "aside-minimize")) {
                            // when "aside-minimize-hover" is present (menu expanded temporarily) or "aside-minimize" is not present (menu expanded long term).
                            setMaxHeight();

                            // only run once
                            classWatcher.disconnect();
                        }
                    });
                } else {
                    setMaxHeight();
                }
            }

            // menu related
            if (window.KTLayoutAsideMenu) {
                const menu = window.KTLayoutAsideMenu.getMenu();
                if (menu) {
                    window.KTLayoutAsideMenu.getMenu().on("submenuToggle", function (submenu) {
                        //let $submenu = $(submenu);
                        //do {
                        //    $submenu.css("max-height", "");
                        //    $submenu.css("max-height", $submenu.css("height"));

                        //    $submenu = $submenu.parent().closest(".menu-submenu");
                        //} while ($submenu.length > 0);

                        const $rootSubmenu = $(submenu).closest("ul.menu-nav > li.menu-item > .menu-submenu");
                        $rootSubmenu.css("max-height", "");
                        setTimeout(function () {
                            $rootSubmenu.css("max-height", $rootSubmenu.css("height"));
                        }, 100);
                    });
                }
            }
        });
    }
})(jQuery);
